<script>
	import '../../styles/styles.css';
	import NavRail from '../../components/NavRail.svelte';
	import TopBar from '../../components/TopBar.svelte';
	import SideMenu from '../../components/SideMenu.svelte';
	import SnackBarContainer from '../../components/SnackBarContainer.svelte';
</script>

<main>
	<NavRail />
	<SideMenu />
	<TopBar />
	<SnackBarContainer />
	<div class="page-container">
		<div class="menu-spacer" />
		<div class="main-container">
			<slot />
		</div>
	</div>
</main>

<style>
	.page-container {
		display: flex;
		flex-direction: row;
		width: 100%;
	}

	.main-container {
		flex-grow: 1;
	}

	main {
	}

	.menu-spacer {
		flex-shrink: 0;
	}

	@media (min-width: 769px) {
		.menu-spacer {
			width: 5rem;
		}
	}

	@media (max-width: 768px) {
		.page-container {
			flex-direction: column;
		}
		.menu-spacer {
			height: 3.5rem;
		}
	}
</style>
